import { render, staticRenderFns } from "./otherDetail.vue?vue&type=template&id=136e0066&scoped=true&"
import script from "./otherDetail.vue?vue&type=script&lang=js&"
export * from "./otherDetail.vue?vue&type=script&lang=js&"
import style0 from "./otherDetail.vue?vue&type=style&index=0&id=136e0066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136e0066",
  null
  
)

export default component.exports